import OrderBy from "api/lib/abstract_query/interfaces/OrderBy";
import ResultColumn from "api/lib/abstract_query/interfaces/ResultColumn";
import ResultColumnFactory from "api/lib/abstract_query/ResultColumnFactory";
import * as _ from "lodash";
import * as React from "react";
import { Button, Card, Checkbox, Icon, Popup } from "semantic-ui-react";

export interface ISortProps {
  resultColumns: ResultColumn[];
  orderBys: OrderBy[];
  onSortChange: (orderBys: OrderBy[]) => void;
}

export interface ISortState {
  orderBys: OrderBy[];
}

export default class Sort extends React.Component<ISortProps, ISortState> {
  private static INITIAL_STATE = {
    orderBys: [],
  };
  constructor(props: ISortProps) {
    super(props);

    this.state = Sort.INITIAL_STATE;
  }

  componentDidMount = () => {
    this.setState({ orderBys: this.props.orderBys || [] });
  };

  public componentDidUpdate = (prevProps, prevState) => {
    if (
      JSON.stringify(this.props.orderBys) !== JSON.stringify(prevProps.orderBys)
    ) {
      this.setState({ orderBys: this.props.orderBys || [] });
    }
  };

  public render() {
    return (
      <React.Fragment>
        <Popup
          trigger={<Icon name="sort content ascending" link={true} />}
          flowing={true}
          hoverable={true}
          on="click"
        >
          <div style={{ height: "300px" }}>
            <Card style={{ height: "100%" }}>
              <Card.Content>
                <Card.Header>Sort by</Card.Header>
                {this.state.orderBys.length <= 0 && (
                  <Card.Meta>Select the fields to sort on</Card.Meta>
                )}
                {this.state.orderBys.length > 0 &&
                  this.renderSelectedOrderBysButtons()}
              </Card.Content>
              <Card.Content>{this.renderAllResultColumns()}</Card.Content>
              <Card.Content extra={true}>
                <div className="ui two buttons">
                  <Button
                    positive={true}
                    size="mini"
                    onClick={this.handeApplyButtonClick}
                  >
                    Apply
                  </Button>
                </div>
              </Card.Content>
            </Card>
          </div>
        </Popup>
        <span>{this.renderSelectedOrderBys()}</span>
      </React.Fragment>
    );
  }
  private renderAllResultColumns = () => {
    const resultColumns = this.props.resultColumns;
    const orderBys = this.state.orderBys;
    return (
      <React.Fragment>
        {resultColumns.map((resultColumn, resultColumnIndex) => {
          const resultColumnColumn = ResultColumnFactory.getColumn(
            resultColumn
          );
          const found = _.find(orderBys, (orderBy) => {
            const thisOrderby = ResultColumnFactory.getColumn(orderBy.column);
            return (
              thisOrderby.name === resultColumnColumn.name &&
              thisOrderby.table === resultColumnColumn.table
            );
          });
          return (
            <div key={btoa(resultColumnColumn.name + resultColumnIndex)}>
              <Checkbox
                defaultChecked={found !== undefined}
                label={resultColumnColumn.name}
                onChange={(e, data: any) =>
                  this.handleSortCheckboxChange(e, data, resultColumn)
                }
              />
            </div>
          );
        })}
      </React.Fragment>
    );
  };

  private renderSelectedOrderBysButtons = () => {
    const orderBys = this.state.orderBys;
    return orderBys.map((orderBy, index) => {
      const columnName = ResultColumnFactory.getColumnName(orderBy.column);
      const iconName = orderBy.asc ? "sort amount up" : "sort amount down";
      return (
        <Button
          key={btoa(columnName + index)}
          content={columnName}
          icon={iconName}
          labelPosition="right"
          onClick={() => this.handleSortToggleClick(index)}
        />
      );
    });
  };

  private renderSelectedOrderBys = () => {
    const orderBys = this.state.orderBys;
    return orderBys.map((orderBy, index) => {
      const columnName = ResultColumnFactory.getColumnName(orderBy.column);
      return <span key={`selectedOrderBys${index}`}>{columnName} </span>;
    });
  };

  private handleSortCheckboxChange = (
    e,
    { checked },
    resultColumn: ResultColumn
  ) => {
    const { orderBys } = this.state;
    const thisOrderBys = [...orderBys];
    if (checked) {
      const found = _.find(orderBys, (orderBy) => {
        const thisOrderby = ResultColumnFactory.getColumn(orderBy.column);
        const resultColumnColumn = ResultColumnFactory.getColumn(resultColumn);
        return (
          thisOrderby.name === resultColumnColumn.name &&
          thisOrderby.table === resultColumnColumn.table
        );
      });
      if (found === undefined) {
        thisOrderBys.push({
          column: resultColumn,
          asc: true,
        });
      }
    } else {
      _.remove(thisOrderBys, (orderBy) => {
        const thisOrderby = ResultColumnFactory.getColumn(orderBy.column);
        const resultColumnColumn = ResultColumnFactory.getColumn(resultColumn);
        return (
          thisOrderby.name === resultColumnColumn.name &&
          thisOrderby.table === resultColumnColumn.table
        );
      });
    }
    this.setState({ orderBys: thisOrderBys });
  };

  private handleSortToggleClick = (orderByIndex: number) => {
    const { orderBys } = this.state;
    const thisOrderBys = [...orderBys];
    thisOrderBys[orderByIndex].asc = !thisOrderBys[orderByIndex].asc;
    this.setState({ orderBys: thisOrderBys });
  };

  private handeApplyButtonClick = () => {
    this.props.onSortChange(this.state.orderBys);
  };
}



// WEBPACK FOOTER //
// ./src/components/Query/Sort.tsx